import { styled } from 'styled-components';
import BonusTemplate from '@/shared/assets/bonus-template.svg';
import BonusTemplateActive from '@/shared/assets/bonus-template-active.svg';
import { Image } from '@/shared/ui/image';
import { WRAPPER } from '@/shared/styles/themes';

export const BonusWrapper = styled.div`
  ${WRAPPER};
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media (max-width: 768px) {
    margin: 0;
    gap: 24px;
  }
`;
export const BonusFilters = styled.div`
  display: flex;
  height: 44px;
  //padding: 0 394px;
  align-items: center;
  gap: 12px;
  align-self: stretch;

  @media (max-width: 1024px) {
    overflow: auto;
  }
  @media (max-width: 768px) {
    overflow: auto;
    :first-child {
      margin-left: 18px;
    }
    :last-child {
      margin-right: 18px;
    }
  }
`;
export const FilterButton = styled.div`
  display: flex;
  height: 40px;
  padding: 0 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 9px;
  flex: 1 0 0;
  cursor: pointer;

  border-radius: 8px;
  background: ${({ $isActive }) => ($isActive ? '#4B444C' : '#27262b')};

  white-space: nowrap;
`;
export const BonusList = styled.div`
  display: grid;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 80px;
  grid-template-columns: repeat(3, 364px);
  grid-auto-rows: 220px;

  //@media (max-width: 900px) {
  //  grid-template-columns: repeat(4, 265px);
  //}

  @media (max-width: 1131px) {
    grid-template-columns: repeat(2, calc(50% - 12px));
    gap: 24px;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 100%);
    gap: 24px;
  }

  //@media (max-width: 640px) {
  //  grid-template-columns: repeat(1, 1fr);
  //  justify-content: center;
  //}
`;

export const BonusItem = styled.div`
  overflow: hidden;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 8px;

  ${({ $isActive }) =>
    $isActive &&
    `
    border: 2px solid #FF9F0A;
  `}

   @media (max-width: 768px) {
border-radius: 0;
  }
`;

`}
  //   &:before {
  //   content: '';
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   z-index: 1;
  //   opacity: 0.4;
  //   border-radius: 8px;
  //   pointer-events: none;
  //   background: ${(props) => props.$generateBg};
  // }
    @media (max-width: 768px) {
   border-radius: 0;
  }
`;
export const BonusItemNew = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  border-radius: 8px;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    //border-radius: 8px;
    background: url(${(props) => props.$bg}) center/cover no-repeat;

    transition: transform 0.3s ease;
    transform-origin: 75% 50%;

    ${({ $isEnable }) =>
      !$isEnable &&
      `
          filter: saturate(0);          
          z-index: 1;
        `}
  }

  &:hover::before {
    transform: scale(1.1);
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;

    background: rgba(25, 38, 75, 0.5);
    background: ${({ $isEnable, $tint }) =>
      $isEnable
        ? `linear-gradient(270deg, rgba(153, 89, 0, 0.00) 30.77%, ${$tint} 100%)`
        : 'rgba(25, 38, 75, 0.5)'};

    ${({ $isActive }) =>
      $isActive &&
      `
      @media (min-width: 769px) {
        border-radius: 8px;
        border: 2px solid #FF9F0A;
      }
      @media (max-width: 768px) {
        border-radius: 0;
        border-top: 2px solid #FF9F0A;
        border-bottom: 2px solid #FF9F0A;
      }
    `}

    z-index: 2;
  }

  > * {
    position: relative;
    z-index: 3;
  }

  @media (max-width: 768px) {
    border-radius: 0;
  }
`;

export const ProviderImage = styled(Image)`
  margin: 0 auto;
`;
export const BonusImage = styled.div`
  background-image:
    linear-gradient(180deg, rgba(19, 19, 21, 0) 0%, #131315 100%),
    url(${(props) => props.$imageUrl});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 150px;
  position: relative;
  z-index: 5;
  aspect-ratio: 136 / 75;

  @media (max-width: 768px) {
    height: 133px;
    background-size: cover;
  }
`;

export const BonusContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 16px;
  gap: 16px;
  border-radius: 8px;
`;

export const EventName = styled.div`
  letter-spacing: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  text-overflow: ellipsis;
  overflow: hidden;
`;
export const BonusName = styled.div`
  color: #fff;
  letter-spacing: 0;
  text-shadow: 0 1.138px 1.138px rgba(11, 21, 46, 0.5);

  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 28.8px */
  white-space: pre-line;
`;
export const BonusTimer = styled.div`
  display: flex;
  width: auto;
  height: 26px;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  border-radius: 1000px;
  background: #131315;
  box-shadow: 0 1px 1px 0 rgba(4, 14, 42, 0.12);
  backdrop-filter: blur(12px);

  ${({ $isActive }) =>
    $isActive &&
    `
    background: #FDB715;
  `}
`;

export const BonusTimerWrapper = styled.div`
  display: flex;
  gap: 2px;
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 5;
`;

export const IconWrapper = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 6px;
  position: absolute;
  right: 8px;
  bottom: 8px;
  border-radius: 10px;
  background: var(--6-a-7-ba-940, rgba(106, 123, 169, 0.4));
  box-shadow:
    0px 1px 1px 0px rgba(255, 255, 255, 0.08) inset,
    0px 1px 1px 0px rgba(4, 14, 42, 0.12);
  backdrop-filter: blur(16px);
`;

export const BonusTemplateImage = styled(BonusTemplate)`
  position: absolute;
  bottom: -10px;
  left: -2px;
`;

export const BonusTemplateImageActive = styled(BonusTemplateActive)`
  position: absolute;
  bottom: -12.5px;
  left: -2px;

  &:before {
    content: '';
    position: absolute;
    width: 50px;
    height: 50px;
    left: 0;
    top: 0;
    background: red;
    border-radius: 50%;
    z-index: 1;
  }
`;

export const BonusDialogContent = styled.div`
  position: relative;
  width: 364px;
  border: 1px solid var(--2-c-344-a-40, #131315);
  background: #131315;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    overflow: auto;
    border-radius: 0px;
    background: #040404;
  }

  ${({ $modBonus }) =>
    $modBonus &&
    `
      width: 420px;
      height: 90vh;

        @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
  `}
`;

export const DescriptionWrapper = styled.div``;

export const BonusDescriptionWrapper = styled.div`
  height: 80px;
  overflow: hidden;
  overflow-y: scroll;
  margin-top: 4px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    height: auto;
    overflow: hidden;
  }
`;

export const DetailItems = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: 5px;
  background: rgba(61, 60, 65, 0.5);
  padding: 8px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  ${({ $fill }) =>
    $fill &&
    `
      flex-basis: 100%;
  `}
`;

export const BurnWarningWrapper = styled.div`
  background-color: #321d26;
  position: relative;
  padding: 20px;
  display: flex;
  justify-content: center;
  width: 80px;
  margin: 0 auto;
  border-radius: 50%;
`;

export const GamesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 155px);
  gap: 12px;
  // margin-top: 8px;
  // padding-bottom: 16px;
  position:relative;
  z-index: 5;

  ${({ $centered }) =>
    $centered &&
    `
      grid-template-columns: repeat(1, 169px);
      justify-content:center;

  `}

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 115px);
    ${({ $centered }) =>
      $centered &&
      `
      grid-template-columns: repeat(1, 115px);
      justify-content:center;

  `}
`;

export const BonusInfoIcon = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  background-color: #3d3c41;
`;
export const TimerBlock = styled.div`
  display: flex;
  height: 40px;
  padding: 0 clamp(5px, 50%, 24px);
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;

  border-radius: 50px;
  background: #202b6c;
  white-space: nowrap;
  overflow: hidden;
`;

export const BonusDetails = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px;
  gap: 24px;
  height: 100%;
  overflow-y: scroll;
  margin-bottom: 74px;

  .customBtn {
    ${TimerBlock} {
      display: block;
      height: auto;
      padding: 0;
      justify-content: initial;
      justify-items: initial;
      align-content: initial;
      align-items: initial;
      border-radius: 0;
      background: transparent;
      white-space: normal;
      overflow: visible;
      text-align: center;
      width: 100%;
      margin: -10px;
    }
  }
`;
